// File map entity types — used when registering/filtering uploaded files
export const FILE_ENTITY_TYPES = {
  ACTOR: "actor",
  ONBOARDING: "onboarding",
  SCENARIO: "scenario",
  CLIENT_IMAGE: "client-image",
} as const;

export type FileEntityType =
  (typeof FILE_ENTITY_TYPES)[keyof typeof FILE_ENTITY_TYPES];

// File upload size limits (in bytes)
export const MAX_IMAGE_UPLOAD_SIZE_BYTES = 5 * 1024 * 1024; // 5 MB — matches UI label
export const MAX_VIDEO_UPLOAD_SIZE_BYTES = 100 * 1024 * 1024; // 100 MB

// Form Status Constants
export const FORM_STATUS = {
  CONCEPT: {
    value: "CONCEPT",
    label: "Concept",
  },
  NOT_READY_FOR_PROMPT: {
    value: "NOT_READY_FOR_PROMPT",
    label: "Not Ready For Prompt",
  },
  PROMPT_IN_PROCESS: {
    value: "PROMPT_IN_PROCESS",
    label: "Prompt In Process",
  },
  READY_FOR_PROMPT: {
    value: "READY_FOR_PROMPT",
    label: "Ready For Prompt",
  },
} as const;

// Helper function to get status label
export const getStatusLabel = (status: string): string => {
  const statusUpper = status.toUpperCase();
  if (statusUpper === FORM_STATUS.CONCEPT.value)
    return FORM_STATUS.CONCEPT.label;
  if (statusUpper === FORM_STATUS.NOT_READY_FOR_PROMPT.value)
    return FORM_STATUS.NOT_READY_FOR_PROMPT.label;
  if (statusUpper === FORM_STATUS.PROMPT_IN_PROCESS.value)
    return FORM_STATUS.PROMPT_IN_PROCESS.label;
  if (statusUpper === FORM_STATUS.READY_FOR_PROMPT.value)
    return FORM_STATUS.READY_FOR_PROMPT.label;
  return status || "Unknown";
};
